import React, { useState, useEffect } from 'react'
import { Input, Form, ControlLabel, Grid, Row, Col, RadioGroup, Radio, Cascader } from 'rsuite'
import classNames from 'classnames'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import { sameAddress } from '../../../constants/address'
import { getLocationZipcode } from '../../../redux/actions/location'
import { startLoading, doneLoading } from '../../../utils/loading'
import { locationZipcode } from '../../location/Location'
import OverlayLoader from '../../OverlayLoader/OverlayLoader'
// import './styles.less'

export default function AddressForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
  haveSameAddressRadio,
  addressWork,
  addressCard,
}) {
  const [schema, setSchema] = useState(_schema)
  const [location, setLocation] = useState([])
  const [isSameAddress, setIsSameAddress] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleLocation()
  }, [])

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await locationZipcode()
    setLocation(location)
    setIsLoading(false)
  }

  const onChangeSameAddressRadio = (value) => {
    if (value === sameAddress.SAME_WORK && addressWork) {
      setValueAllField(addressWork)
    } else if (value === sameAddress.SAME_CARD && addressCard) {
      setValueAllField(addressCard)
    } else {
      setValueAllField({})
      setIsSameAddress(false)
    }
  }

  const setValueAllField = (value) => {
    if (value) {
      setValue(schema.buildingName.name, value[schema.buildingName.name])
      setValue(schema.roomNumber.name, value[schema.roomNumber.name])
      setValue(schema.houseNumber.name, value[schema.houseNumber.name])
      setValue(schema.villageNumber.name, value[schema.villageNumber.name])
      setValue(schema.lane.name, value[schema.lane.name])
      setValue(schema.villageName.name, value[schema.villageName.name])
      setValue(schema.road.name, value[schema.road.name])
      setValue(schema.location.name, value[schema.location.name])
      clearErrors()
      setIsSameAddress(true)
    }
  }

  const Styles = {
    marginBottom10: { marginBottom: 10 },
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Grid fluid>
        <Form fluid className="address-form">
          {haveSameAddressRadio &&
            ((addressWork?.location && schema.sameCardLabel) ||
              (addressCard?.location && schema.sameWorkLabel)) && (
              <Row style={Styles.marginBottom10}>
                <Controller
                  name="sameAddress"
                  defaultValue=""
                  control={control}
                  render={(props) => {
                    return (
                      <RadioGroup
                        inline
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          onChangeSameAddressRadio(value)
                        }}
                      >
                        {addressWork?.location && schema.sameWorkLabel && (
                          <Radio value={sameAddress.SAME_WORK}>{schema.sameWorkLabel}</Radio>
                        )}
                        {addressCard?.location && schema.sameCardLabel && (
                          <Radio value={sameAddress.SAME_CARD}>{schema.sameCardLabel}</Radio>
                        )}
                        {((addressWork?.location && schema.sameCardLabel) ||
                          (addressCard?.location && schema.sameWorkLabel)) && (
                          <Radio value={sameAddress.NOT_SAME}>{schema.notSameAddressLabel}</Radio>
                        )}
                      </RadioGroup>
                    )
                  }}
                />
              </Row>
            )}

          {schema.urbanType && (
            <Row style={Styles.marginBottom10}>
              <Col xs={24} sm={24} md={18} lg={18}>
                <ControlLabel
                  className={classNames(isRequired(schema.urbanType.validators) && 'required')}
                >
                  {schema.urbanType.label}
                </ControlLabel>
                <ErrorMessage error={errors.urbanType} />
                <Controller
                  name={schema.urbanType.name}
                  defaultValue={schema.urbanType.value}
                  control={control}
                  render={(props) => {
                    return (
                      <RadioGroup
                        inline
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      >
                        {schema.urbanType.options.map((item) => {
                          return <Radio value={item.value}>{item.label}</Radio>
                        })}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            </Row>
          )}

          {schema.addressName && (
            <Row style={Styles.marginBottom10}>
              <Col
                xs={24}
                sm={24}
                md={schema.directorName ? 12 : 18}
                lg={schema.directorName ? 12 : 18}
              >
                <ControlLabel
                  className={classNames(isRequired(schema.addressName.validators) && 'required')}
                >
                  {schema.addressName.label}
                </ControlLabel>
                <ErrorMessage error={errors.addressName} />
                <Input
                  placeholder={schema.addressName.label}
                  defaultValue={schema.addressName.value}
                  name={schema.addressName.name}
                  inputRef={register(isValidators(schema.addressName.validators))}
                  disabled={isSameAddress}
                />
              </Col>
              {schema.directorName && (
                <Col xs={24} sm={24} md={12} lg={12}>
                  <ControlLabel
                    className={classNames(isRequired(schema.directorName.validators) && 'required')}
                  >
                    {schema.directorName.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.directorName} />
                  <Input
                    placeholder={schema.directorName.label}
                    defaultValue={schema.directorName.value}
                    name={schema.directorName.name}
                    inputRef={register(isValidators(schema.directorName.validators))}
                    disabled={isSameAddress}
                  />
                </Col>
              )}
            </Row>
          )}

          {/* <FormGroup> */}
          <Row style={Styles.marginBottom10}>
            {schema.buildingName && (
              <Col xs={24} sm={24} md={18} lg={18}>
                <ControlLabel
                  className={classNames(isRequired(schema.buildingName.validators) && 'required')}
                >
                  {schema.buildingName.label}
                </ControlLabel>
                <ErrorMessage error={errors.buildingName} />
                <Input
                  placeholder={schema.buildingName.label}
                  defaultValue={schema.buildingName.value}
                  name={schema.buildingName.name}
                  inputRef={register(isValidators(schema.buildingName.validators))}
                  disabled={isSameAddress}
                />
              </Col>
            )}

            {schema.roomNumber && (
              <Col xs={24} sm={24} md={6} lg={6}>
                <ControlLabel
                  className={classNames(isRequired(schema.roomNumber.validators) && 'required')}
                >
                  {schema.roomNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.roomNumber} />
                <Input
                  placeholder={schema.roomNumber.label}
                  defaultValue={schema.roomNumber.value}
                  name={schema.roomNumber.name}
                  inputRef={register(isValidators(schema.roomNumber.validators))}
                  disabled={isSameAddress}
                />
              </Col>
            )}
          </Row>
          {/* </FormGroup> */}

          {/* <FormGroup> */}
          <Row style={Styles.marginBottom10}>
            {schema.houseNumber && (
              <Col xs={24} sm={24} md={5} lg={5}>
                <ControlLabel
                  className={classNames(isRequired(schema.houseNumber.validators) && 'required')}
                >
                  {schema.houseNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.houseNumber} />
                <Input
                  placeholder={schema.houseNumber.label}
                  defaultValue={schema.houseNumber.value}
                  name={schema.houseNumber.name}
                  inputRef={register(isValidators(schema.houseNumber.validators))}
                  disabled={isSameAddress}
                />
              </Col>
            )}

            <Col xs={24} sm={24} md={3} lg={3}>
              <ControlLabel
                className={classNames(isRequired(schema.villageNumber.validators) && 'required')}
              >
                {schema.villageNumber.label}
              </ControlLabel>
              <ErrorMessage error={errors.villageNumber} />
              <Input
                placeholder={schema.villageNumber.label}
                defaultValue={schema.villageNumber.value}
                name={schema.villageNumber.name}
                inputRef={register(isValidators(schema.villageNumber.validators))}
                disabled={isSameAddress}
              />
            </Col>
            <Col xs={24} sm={24} md={8} lg={8}>
              <ControlLabel
                className={classNames(isRequired(schema.lane.validators) && 'required')}
              >
                {schema.lane.label}
              </ControlLabel>
              <ErrorMessage error={errors.lane} />
              <Input
                placeholder={schema.lane.label}
                defaultValue={schema.lane.value}
                name={schema.lane.name}
                inputRef={register(isValidators(schema.lane.validators))}
                disabled={isSameAddress}
              />
            </Col>
            <Col xs={24} sm={24} md={8} lg={8}>
              <ControlLabel
                className={classNames(isRequired(schema.villageName.validators) && 'required')}
              >
                {schema.villageName.label}
              </ControlLabel>
              <ErrorMessage error={errors.villageName} />
              <Input
                placeholder={schema.villageName.label}
                defaultValue={schema.villageName.value}
                name={schema.villageName.name}
                inputRef={register(isValidators(schema.villageName.validators))}
                disabled={isSameAddress}
              />
            </Col>
          </Row>
          {/* </FormGroup> */}
          {/* <FormGroup> */}
          <Row style={Styles.marginBottom10}>
            <Col xs={24} sm={24} md={8} lg={8}>
              <ControlLabel
                className={classNames(isRequired(schema.road.validators) && 'required')}
              >
                {schema.road.label}
              </ControlLabel>
              <ErrorMessage error={errors.road} />
              <Input
                placeholder={schema.road.label}
                defaultValue={schema.road.value}
                name={schema.road.name}
                inputRef={register(isValidators(schema.road.validators))}
                disabled={isSameAddress}
              />
            </Col>
            <Col xs={24} sm={24} md={16} lg={16}>
              <ControlLabel
                className={classNames(isRequired(schema.location.validators) && 'required')}
              >
                {schema.location.label}
              </ControlLabel>
              <ErrorMessage error={errors.location} />
              <Controller
                name={schema.location.name}
                control={control}
                defaultValue={schema.location.value}
                rules={isValidators(schema.location.validators)}
                render={(props) => {
                  return (
                    <Cascader
                      size="lg"
                      block
                      menuWidth={180}
                      data={location}
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                      placeholder={schema.location.label}
                      disabled={isSameAddress}
                      // renderValue={(value, selectedItems, selectedElement) => (
                      //   <span>
                      //     <span style={{ color: '#575757' }}>
                      //       <i className="rs-icon rs-icon-map-marker" />
                      //     </span>{' '}
                      //     {selectedItems.map((item) => item.label).join(' , ')}
                      //   </span>
                      // )}
                    ></Cascader>
                    // <LocationDropdown
                    //   placeholder={schema.location.label}
                    //   value={props.value}
                    //   location={location}
                    //   onChange={(value) => {
                    //     props.onChange(value)
                    //   }}
                    //   disabled={isSameAddress}
                    // />
                  )
                }}
              />
            </Col>
          </Row>
          {/* </FormGroup> */}
        </Form>
      </Grid>
    </>
  )
}
